import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

import '../../SetupWizard.scss';

import SetupWizardTitleHeader from 'contents/SetupWizard/components/SetupWizardTitleHeader';
import {parseMessage} from 'lib/stringHelper';
import SetupWizardStepButton from 'contents/SetupWizard/components/SetupWizardStepButton';

const StuckTipsDetection = forwardRef(({onCalibrate}, ref) => (
  <div ref={ref} className="step-vision-calibration-substep-3-v2">
    <SetupWizardTitleHeader classNameFormat="vision-calibration" intlTextFormat="visionCalibration.v2" />
    <SetupWizardStepButton
      onClick={onCalibrate}
      label={parseMessage('setupWizard.step.visionCalibration.v2.firstButton')}
    />
  </div>
));

StuckTipsDetection.propTypes = {
  onCalibrate: PropTypes.func.isRequired,
};

const VisionCalibrationV2SetupWizard = () => {};

VisionCalibrationV2SetupWizard.StuckTipsDetection = StuckTipsDetection;

export default VisionCalibrationV2SetupWizard;
